<div class="flex justify-start items-center w-full">
  <input
    type="checkbox"
    [formControl]="control()"
    [name]="componentId"
  />

  <div class="text-sm pl-2">
    <ng-content></ng-content>
  </div>
</div>
